import { makeAutoObservable } from 'mobx';
import { isEqual } from 'lodash';
import { UsageExampleLanguages } from './ui-store.consts';

export class UiStore {
  windowDimensions: { width: number; height: number } = undefined;
  isOnline: boolean = true;
  usageExampleLanguage: UsageExampleLanguages = UsageExampleLanguages.Shell;

  constructor() {
    makeAutoObservable(this);
  }

  setWindowDimensions = (dimensions: { width: number; height: number }) => {
    if (dimensions && !isEqual(dimensions, this.windowDimensions)) {
      this.windowDimensions = dimensions;
    }
  };

  setIsOnline = (isOnline: boolean) => {
    this.isOnline = isOnline;
  };

  setUsageExampleLanguage = (lang: UsageExampleLanguages) => {
    this.usageExampleLanguage = lang || UsageExampleLanguages.Shell;
  }
}